import { render, staticRenderFns } from "./Prize_received_modal.vue?vue&type=template&id=030d348d"
import script from "./Prize_received_modal.vue?vue&type=script&lang=js"
export * from "./Prize_received_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports